import { snakeCaseToTitleCase } from '@utils/stringFormat';

import {
  METHOD_LABEL_OVERRIDES,
  preDefinedKey,
  TransactionHistoryDescription
} from '../constants';

export const getTransactionHistoryKeys = (
  paymentMode: string,
  paidAmount: string,
  type?: string
) => {
  let transactionHistoryKeys: string[] = [];

  if (type === 'discount' || type === 'closed') {
    transactionHistoryKeys = [
      preDefinedKey.paymentMode,
      preDefinedKey.paidAt,
      preDefinedKey.paymentDescription
    ];
  } else if (paymentMode === 'manual') {
    transactionHistoryKeys = [
      preDefinedKey.paymentMode,
      preDefinedKey.transactionId,
      preDefinedKey.paymentDescription,
      preDefinedKey.paidAt,
      preDefinedKey.markedPaidAt
    ];
  } else {
    transactionHistoryKeys = [
      preDefinedKey.paymentMode,
      preDefinedKey.transactionId,
      preDefinedKey.paidAt,
      preDefinedKey.utr
    ];
  }

  if (paymentMode === 'automatic' && paidAmount) {
    transactionHistoryKeys.push(preDefinedKey.settledAt);
  }

  return transactionHistoryKeys;
};

export const getTransactionHistoryTitle = (
  key: string,
  paymentMode: string,
  paymentMethod: string,
  type?: string
) => {
  const title =
    TransactionHistoryDescription[
      key as keyof typeof TransactionHistoryDescription
    ];
  if (key === 'payment_mode') {
    if (type === 'discount') {
      return 'Discount';
    }
    if (type === 'closed') {
      return 'Closed';
    }
    if (paymentMode === 'manual') {
      return `${title} Offline via ${paymentMethod}`;
    }
    if (paymentMode === 'automatic' && paymentMethod !== '') {
      return `${title} Online via ${
        METHOD_LABEL_OVERRIDES[paymentMethod] ||
        snakeCaseToTitleCase(paymentMethod)
      }`;
    }
    return `${title} via Cofee`;
  }
  if (type === 'discount' && key === 'paid_at') {
    return 'Discounted On';
  }
  if (type === 'closed' && key === 'paid_at') {
    return 'Closed on';
  }
  return title;
};
